// src/components/Footer.js

import React from 'react';

const Footer = () => {
  return (
    <footer className="p-4 text-center border-t-4 border-arcade-yellow bg-gradient-to-r from-arcade-blue to-arcade-purple">
      <p className="pixel-art">&copy; 2024 TrishankV</p>
    </footer>
  );
};

export default Footer;
